import React from 'react';
import PropTypes from 'prop-types';
import { copy, cutoffs } from '../../constants';

import styles from './styles/EditTitle.scss';

const EditTitle = ({ newPortfolioName, setNewPortfolioName }) => {
    const onChange = e => {
        const { value } = e.currentTarget;
        setNewPortfolioName(value);
    };

    return (
        <input
            data-tn="edit-folder-name-input"
            className={styles.titleInput}
            type="text"
            maxLength={cutoffs.MAX_CHAR_TITLE}
            onChange={onChange}
            value={newPortfolioName}
            placeholder={copy.createFolder.PLACEHOLDER_NAME}
        />
    );
};

EditTitle.defaultProps = {
    isBorderless: false,
};

EditTitle.propTypes = {
    isBorderless: PropTypes.bool,
    newPortfolioName: PropTypes.string,
    setNewPortfolioName: PropTypes.func,
};

export { EditTitle };
